import * as React from 'react';
import RoomIcon from '@material-ui/icons/Room';
import { geoJSON } from '../../ChartMap';
import { setISO2CDPipe } from '../geo/pipeline';
import { LeafletMarker } from '../../LeafletMap';
import { MapDataSourceId } from '../../../models/MapDataSource';
import { useMapStore } from '../../../hooks/useMapStore';
import { useHookSubscribe } from '../../../../react-rxjs';
import { useService } from '../../../hooks/useService';
import { ServicesMaps } from '../../../MapReportingProvider';
import { DictionariesService } from '@sa/rep-mdm';
import _ from 'lodash';

export const Marker: React.FC = props => {
  const [coordinates, setCoordinates] = React.useState<[number, number] | null>(null);
  const store = useMapStore();
  const dictionaryService = useService<DictionariesService>(ServicesMaps.Dictionaries);
  const dataSourceId = useHookSubscribe(MapDataSourceId.Default, store.dataSourceId$);
  const dimensions = useHookSubscribe([], store.dimensions$);

  const geojson = React.useMemo(() => setISO2CDPipe(geoJSON), [geoJSON]);

  React.useEffect(() => {
    setCoordinates(null);
    const dimensionCountry = dimensions.find(e => e.hierarchy.includes('reporting_countries'));
    if (dataSourceId === MapDataSourceId.UNComtrade && dimensionCountry) {
      const valueStream$ = store.dimensionsValues.get(dimensionCountry.id);

      const subscr = valueStream$?.subscribe(async value => {
        setCoordinates(null);
        const dictionary = await dictionaryService.getDictionary({ id: dimensionCountry.identifier, parameters: {} });
        const items = await dictionary.getAll();
        const item = items.find(e => e.getValue<unknown>('id') === value);
        const iso2cd = item?.getValue<string>('code');
        const feature = geojson.features.find(e => e.properties?.ISO2CD === iso2cd);
        const geometry = feature?.geometry;
        if (geometry) {
          const coords = (geometry.type === "MultiPolygon" ? _.maxBy(geometry.coordinates as any, (e: any) => e.flat().length) : geometry.coordinates).flat();
          const c1 = _.mean(coords.map(e => e[1]));
          const c2 = _.mean(coords.map(e => e[0]));
          setCoordinates([c1, c2]);
        }
      });
      return () => {
        subscr?.unsubscribe();
      }
    }
  }, [dataSourceId, dimensions, geojson]);
  
  if (!coordinates) {
    return null;
  }
  return (
    <LeafletMarker coordinates={coordinates} iconSize={[48, 48]} iconAnchor={[24, 48]}>
      <RoomIcon stroke="#606060" strokeWidth={1} fill="rgb(168,222,17)" />
    </LeafletMarker>
  );
}